import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { loadStripe, Stripe } from '@stripe/stripe-js';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireFunctions } from '@angular/fire/functions';

interface curso {
  empresaFoto: string;
  empresaId: string;
  empresaNombre: string;
  foto: string;
  idioma: string;
  instructorFoto: string;
  instructorId: string;
  instructorNombre: string;
  precioFinal: number;
  porcentajeDescuento: number;
  precioOriginal: number;
  resumen: string;
  titulo: string;
}

@Component({
  selector: 'comprar-curso',
  templateUrl: './comprar-curso.component.html',
  styleUrls: ['./comprar-curso.component.css']
})
export class ComprarCursoComponent implements OnInit {

  stripeStatus: string;
  usuario = JSON.parse(localStorage.getItem("user"));
  token = JSON.parse(localStorage.getItem('token'));
  usuarioLoggeado = 0;

  constructor(
    private route: ActivatedRoute,
    private functions: AngularFireFunctions,
    public afAuth: AngularFireAuth,
    private afs: AngularFirestore,
    public router: Router,
  ) {
    this.stripeStatus = '';
  }

  STRIPE_PUBLISHABLE_KEY = "pk_live_51J0sHxK9jeRSVMnkxl5ABQUNRQ4tssE6hlcXxrRZdO9Uenu5EYuEiuLicbATJCkFRyNJGZ390foCYpGTBSe5lxfh00SjeQZPK1";

  id = this.route.snapshot.paramMap.get('id');
  curso: curso;
  clases: any[] = [];
  loaded = 0;

  ngOnInit() {
    if (this.token) {
      if (this.token == 'estudiante' || this.token == 'superadmin') {
        this.usuarioLoggeado = 1;
      }
    } else {
      this.usuarioLoggeado = 0;
      this.router.navigate(['curso/' + this.id]);
    }

    this.stripeStatus = this.getStripeStatus();
    if (this.id) {
      this.cargarCurso();
    } else {
      this.loaded = 1;
    }
  }

  cargarCurso() {
    this.afs.collection('cursos').doc(this.id).ref.get().then((snap) => {
      const curso = snap.data();
      this.curso = {
        empresaFoto: curso['empresaFoto'],
        empresaId: curso['empresaId'],
        empresaNombre: curso['empresaNombre'],
        foto: curso['foto'],
        idioma: curso['idioma'],
        instructorFoto: curso['instructorFoto'],
        instructorId: curso['instructorId'],
        instructorNombre: curso['instructorNombre'],
        precioFinal: curso['precioFinal'],
        porcentajeDescuento: curso['porcentajeDescuento'],
        precioOriginal: curso['precioOriginal'],
        resumen: curso['resumen'],
        titulo: curso['titulo'],
      }
    }).then(async () => {
      this.loaded = 1;
      if (this.stripeStatus == "success") {
        await this.functions.httpsCallable("invoiceEmail")({
          nombre: this.usuario.nombreCompleto,
          curso: this.curso.titulo,
          instructor: this.curso.instructorNombre,
          precio: this.curso.precioFinal,
          email: this.usuario.email,
        }).toPromise();
      }
    }).catch((error) => {
      console.log(error)
    })
  }

  getStripeStatus(): string {
    let action = this.route.snapshot.queryParamMap.get('action');
    console.log('action = ', action);
    if (action && action == 'cancel' || action == 'success')
      return action;
    return '';
  }

  async checkoutFirebase(cursoId: string) {
    var stripe = await loadStripe(this.STRIPE_PUBLISHABLE_KEY);
    this.functions.httpsCallable("stripeCheckout")({
      id: this.id,
      cursoFoto: this.curso.foto,
      cursoResumen: this.curso.resumen,
      cursoPrecioFinal: this.curso.precioFinal,
      cursoTitulo: this.curso.titulo,
      instructorId: this.curso.instructorId,
      instructorNombre: this.curso.instructorNombre,
      usuarioUid: this.usuario.uid,
      usuarioNombreCompleto: this.usuario.nombreCompleto,
    }).subscribe(result => {
      stripe.redirectToCheckout({
        sessionId: result,
      }).then(function (result) {
        console.log(result.error.message);
      });
    });
  }

  goBack() {
    window.history.back();
  }

}
